export default {
  shouldLoadMore(notification) {
    return parseInt(notification.totalCount) !== notification.data.length;
  },
  hasNotificationNotRead(notification) {
    return parseInt(notification.totalUnread) !== 0;
  },
  listNotification(notification) {
    if (!Array.isArray(notification.data)) {
      return notification;
    }

    return notification.data;
  },
  notificationEnabled() {
    return process.env.NOTIFICATION_API && process.env.NOTIFICATION_API_KEY;
  }
};
